import { z } from "zod";

export const schema = z.object({
  avatar: z.string().nullable(),
  hasMarkings: z.boolean(),
  vehicleTypeUuid: z.string().min(1, "Please select a vehicle type"),
  nickname: z.string().optional(),
  capacity: z.number(),
  bags: z.number(),
  vehicleOwnerFee: z.number().min(0).max(100),
});

export type EditVehicleFormData = z.infer<typeof schema>;
